'use client'
/* eslint-disable quotes */
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../../../lib/Media'
import NoImg from '../icons/NoImg'
import Link from 'next/link'

export const CategoryCollectionWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const CategoryCollectionGridWrp = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
  grid-gap: 1rem;
  padding: 0 1.5rem;
  ${SCREEN_SIZE.From.MobileL} {
    display: none;
  }
`

export const CategoryItem = styled.div`
  position: relative;
  height: fit-content;
  background-color: ${({ theme }) => theme.white};
  ${SCREEN_SIZE.Below.MobileL} {
    min-width: 16rem;
    max-width: 100%;
  }
`

export const StyledLink = styled.div`
  height: 100%;
  overflow: hidden;
  text-align: center;
`
export const StyledCategoryImage = styled.div`
  height: 147px;
  width: 147px;
  ${({ collectionType }) =>
    collectionType === 'brand' &&
    `
      display: flex;
      align-items: center;
      background: #f6f6f6;
    `}
  margin-bottom:${({ collectionType }) =>
    collectionType === 'brand' ? '0.8rem' : '2.6rem'};
  object-fit: cover;
  border-radius: 8px;
  ${SCREEN_SIZE.Below.MobileL} {
    height: 8.3rem;
  }
`
export const StyledCategoryText = styled.p`
  padding: 1.5rem;
  color: ${({ theme }) => theme.darkTextColor};
  font-size: 1.6rem;
  line-height: 1.8rem;
  font-weight: 600;
  background-color: ${({ theme }) => theme.white};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  ${SCREEN_SIZE.From.Tablet} {
    font-weight: 400;
    color: #121414;
    cursor: pointer;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
`

export const StyledA = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const MedicineIcon = styled(NoImg)`
  width: 100%;
  height: 17.7rem;
  padding-top: 1rem;
  ${SCREEN_SIZE.Below.MobileL} {
    height: 8.5rem;
  }
`
